import { ComponentType, createElement, ReactNode } from "react";

import { TRouteGuard } from "./LazyRoute";

/**
 * Creates a guard component with the specified props.
 * @param guard The guard component to wrap around the children.
 * @param props The props to be passed to the guard component.
 * @returns A new guard component that includes the specified props.
 */
export function guardWithProps<TGuardProps extends object>(
  guard: ComponentType<TGuardProps & { children: ReactNode }>,
  props: TGuardProps,
): TRouteGuard {
  const guardWithOptionalChildren = guard as ComponentType<TGuardProps & { children?: ReactNode }>;

  return ({ children }: { children: ReactNode }) => createElement(guardWithOptionalChildren, props, children);
}
